const initalState = null
const initalStateArray = []

const recipientUserSeqReducer = (state = initalStateArray, action) => {
	const {type, data} = action

	switch (type) {
		case "RECIPIENT_USER_SEQ":
			return data
		
		default:
			return state
	}
}

const recipientUserRecordReducer = (state = initalStateArray, action) => {
	const {type, data} = action

	switch (type) {
		case "RECIPIENT_USER_RECORD":
			return data
		
		default:
			return state
	}
}


export {
	recipientUserSeqReducer,
	recipientUserRecordReducer,
}